import { Download, FileText, BookOpen, IndianRupee } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const REPORTS = [
  { key: "institutions", label: "Institutions Report", desc: "All institutions with plan, courses, status and expiry.", icon: FileText },
  { key: "courses", label: "Course Report", desc: "All courses with institution, category, fee and status.", icon: BookOpen },
  { key: "revenue", label: "Revenue Report", desc: "All payments with plan, amount, GST and dates.", icon: IndianRupee },
];

export default function AdminReports() {
  const download = async (key) => {
    try {
      const res = await api.get(`/admin/reports/${key}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url; a.download = `${key}.csv`; a.click();
      window.URL.revokeObjectURL(url);
      toast.success("Downloaded");
    } catch { toast.error("Download failed"); }
  };

  return (
    <div>
      <h1 className="mb-4 font-heading text-2xl font-bold tracking-tight text-slate-900">Reports</h1>
      <div className="grid gap-4 md:grid-cols-3">
        {REPORTS.map((r) => (
          <div key={r.key} className="rounded-xl border border-slate-200 bg-white p-6">
            <r.icon className="h-6 w-6 text-blue-800" />
            <h3 className="mt-3 font-heading font-semibold text-slate-900">{r.label}</h3>
            <p className="mt-1 text-sm text-slate-500">{r.desc}</p>
            <Button className="mt-4 bg-blue-800 hover:bg-blue-900" size="sm" onClick={() => download(r.key)} data-testid={`download-${r.key}`}>
              <Download className="mr-1.5 h-4 w-4" /> Download CSV
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
